import { BellRing, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { messaggioPromemoria, openWhatsApp } from "@/lib/whatsapp";

export const PromemoriaButton = ({ a, negozio, onDone }) => {
  const click = async (e) => {
    e.stopPropagation();
    if (!a.cliente_telefono) return toast.error("Il cliente non ha un numero di telefono");
    openWhatsApp(a.cliente_telefono, messaggioPromemoria(a, negozio));
    await api.post(`/appuntamenti/${a.id}/promemoria`).catch(() => {});
    onDone?.();
  };
  return (
    <Button type="button" size="sm" variant="outline" onClick={click} data-testid={`app-promemoria-${a.id}`} title="Ricorda l'appuntamento su WhatsApp"
      className={a.promemoria_at ? "border-emerald-300 text-emerald-700" : "border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100"}>
      {a.promemoria_at ? <CheckCircle2 className="mr-1 h-4 w-4" /> : <BellRing className="mr-1 h-4 w-4" />}
      {a.promemoria_at ? "Ricordato" : "Ricorda"}
    </Button>
  );
};
